import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyCountdown() {
  // Start with 23:59:51 in seconds
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 51);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return {
      h: h.toString().padStart(2, '0'),
      m: m.toString().padStart(2, '0'),
      s: s.toString().padStart(2, '0')
    };
  };
  const {
    h,
    m,
    s
  } = formatTime(timeLeft);
  const units = [{
    value: h,
    label: 'Horas'
  }, {
    value: m,
    label: 'Min'
  }, {
    value: s,
    label: 'Seg'
  }];
  return <section className="w-full py-10 px-4 bg-base flex justify-center" data-id="element-269">
      <div className="max-w-3xl w-full" data-id="element-270">
        <div className="text-center mb-8 flex flex-col items-center gap-4" data-id="element-271">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-alt border border-primary/30 text-xs font-bold uppercase tracking-widest text-primary" data-id="element-272">
            <Clock size={14} data-id="element-273" /> Precio de lanzamiento
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-text-main" data-id="element-274">
            La oferta termina en
          </h2>
        </div>

        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-alt border border-primary/40 rounded-3xl p-6 md:p-10 text-center relative overflow-hidden shadow-[0_0_40px_rgba(123,63,242,0.15)]" data-id="element-275">
          <div className="flex justify-center items-start gap-2 md:gap-4 mb-8" data-id="element-276">
            {units.map((unit, i) => <Fragment key={unit.label} data-id="element-277">
                <div className="flex flex-col items-center flex-1 max-w-[140px]" data-id="element-278">
                  <div className="w-full aspect-square md:aspect-[4/3] flex items-center justify-center text-4xl md:text-6xl lg:text-7xl font-mono font-bold text-text-main bg-base rounded-2xl border border-primary/20 tabular-nums" data-id="element-279">
                    {unit.value}
                  </div>
                  <span className="text-text-muted text-xs md:text-sm mt-3 font-semibold uppercase tracking-[0.2em]" data-id="element-280">
                    {unit.label}
                  </span>
                </div>
                {i < units.length - 1 && <div className="flex items-center h-[72px] md:h-[120px] lg:h-[140px] text-3xl md:text-5xl text-primary/60 font-bold" data-id="element-281">
                    :
                  </div>}
              </Fragment>)}
          </div>

          <div className="h-px w-full bg-primary/15 mb-6" data-id="element-282" />

          <p className="text-base md:text-xl font-bold text-yellow-400 flex items-center justify-center gap-2" data-id="element-283">
            <span aria-hidden="true" data-id="element-284">⚠️</span>
            <span data-id="element-285">Después sube $10.000 ARS. No vuelve.</span>
          </p>
        </motion.div>

        <div className="mt-8 bg-alt rounded-full p-2 border border-red-500/20 flex flex-col md:flex-row items-center gap-4 max-w-xl mx-auto" data-id="element-286">
          <div className="flex items-center gap-2 px-4 py-1" data-id="element-287">
            <span className="relative flex h-3 w-3" data-id="element-288">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-289"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-290"></span>
            </span>
            <span className="text-sm font-bold text-text-main whitespace-nowrap" data-id="element-291">
              72% de los cupos tomados
            </span>
          </div>
          <div className="flex-grow w-full px-4 md:px-0 md:pr-4 pb-2 md:pb-0" data-id="element-292">
            <div className="h-3 w-full bg-base rounded-full overflow-hidden border border-alt" data-id="element-293">
              <div className="h-full bg-cta rounded-full" style={{
              width: '72%'
            }} data-id="element-294"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}